module.exports = __webpack_public_path__ + "static/media/Arrow.21b2d90b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Arrow.svg
// module id = 442
// module chunks = 0